import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { useLogo, API } from "../App";
import { Button } from "./ui/button";

export const PublicHeader = () => {
  const [navPages, setNavPages] = useState([]);
  const { logoUrl } = useLogo();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    axios
      .get(`${API}/site/pages`)
      .then((res) => setNavPages((res.data || []).filter((p) => p.show_in_nav)))
      .catch(() => {});
  }, []);

  const isActive = (path) => location.pathname === path;
  const linkCls = (active) =>
    `text-sm whitespace-nowrap hover:text-emerald-500 transition-colors ${
      active ? "text-emerald-500 font-semibold" : "text-slate-600 dark:text-slate-300"
    }`;

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 dark:bg-slate-950/80 border-b border-slate-200 dark:border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 gap-4">
          <Link to="/" className="flex items-center gap-3 flex-shrink-0" data-testid="site-home-link">
            <img src={logoUrl} alt="PRC勤怠" className="w-9 h-9 object-contain rounded-xl" />
            <span className="font-bold text-lg tracking-tight">PRC勤怠</span>
          </Link>
          <nav className="hidden md:flex items-center gap-5 overflow-x-auto">
            {navPages.map((p) => (
              <Link key={p.slug} to={`/p/${p.slug}`} className={linkCls(isActive(`/p/${p.slug}`))} data-testid={`nav-link-${p.slug}`}>
                {p.nav_label}
              </Link>
            ))}
            <Link to="/guide" className={linkCls(isActive("/guide"))} data-testid="nav-link-guide">
              取扱説明書
            </Link>
            <Link to="/estimate" className={linkCls(isActive("/estimate"))} data-testid="nav-link-estimate">
              導入見積
            </Link>
          </nav>
          <Button variant="outline" size="sm" onClick={() => navigate("/login")} data-testid="site-login-btn" className="flex-shrink-0">
            管理者ログイン
          </Button>
        </div>
      </div>
    </header>
  );
};
